import React from 'react'
import { GreetingImage } from './GreetingImage'
import { GreetingHeading } from './GreetingHeading'
import { GreetingSubheading } from './GreetingSubheading'

import '../../styles/ConciergeModule/Greeting.scss'

interface GreetingProps {
  image: { url: string; altText: string }
  heading: string
  headingFallback: string
  subheading: string
  subheadingFallback: string
  mobileSubheading?: string
}

export const Greeting = ({ image, heading, headingFallback, subheading, subheadingFallback, mobileSubheading }: GreetingProps) => {
  return (
    <div className={`greeting${!image?.url ? ' greeting--no-image' : ''}`}>
      {image?.url && <GreetingImage url={image.url} altText={image?.altText} />}
      <GreetingHeading heading={heading} fallback={headingFallback} />
      <GreetingSubheading subheading={subheading} fallback={subheadingFallback} mobileSubheading={mobileSubheading} />
    </div>
  )
}
